import { render, staticRenderFns } from "./OfferPage.vue?vue&type=template&id=02dd7fc4&scoped=true&"
import script from "./OfferPage.vue?vue&type=script&lang=js&"
export * from "./OfferPage.vue?vue&type=script&lang=js&"
import style0 from "./OfferPage.vue?vue&type=style&index=0&id=02dd7fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd7fc4",
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn,QImg})
